/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/validateTwoFactor.scss';

import {ErrorType, Loader, WithBackground} from '@dvrd/dvr-controls';
import React, {MouseEventHandler, useRef} from 'react';
import classNames from 'classnames';
import {BolmateButton} from "../../controls";
import CodeInputController, {CodeInputRef} from "../../controls/codeInput/codeInputController";

interface Props {
    onSubmit: (code: string) => void;
    onClose: MouseEventHandler;
    active: boolean;
    loading: boolean;
    error: ErrorType;
    explanation?: string;
}

export default function ValidateTwoFactor(props: Props) {
    const {active, onClose, error, loading, onSubmit, explanation} = props;
    const codeInputRef = useRef<CodeInputRef>(null);

    function onCheck() {
        codeInputRef.current?.submit();
    }

    const explanationText = explanation ?? 'Vul hieronder de tweestapsverificatie code in.';
    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='login-validation validate-two-factor'>
                <div className='header-container'>
                    <label className='header-title'>Tweestapsverificatie</label>
                </div>
                <div className='body-container'>
                    <Loader active={loading}/>
                    <label>{explanationText}<br/><br/>Deze code wordt gegenereerd door een app op uw telefoon (meestal
                        Google Authenticator).</label>
                    <CodeInputController onSubmit={onSubmit} length={6} ref={codeInputRef} autoSubmit numbersOnly/>
                    <label className={classNames('error-label', !!error && 'visible')}>{error}</label>
                </div>
            </div>
        </WithBackground>
    )
}